module.exports = __webpack_public_path__ + "static/images/monet/help_icon.png";